import GeneralSection from "./GeneralSection";

const GeneralPages = ({ data }) => {
  return (
    <div className="general">
      {data?.map((section, index) => {
        return (
          <div className="general__page" key={index}>
            <GeneralSection data={section} />
          </div>
        );
      })}
    </div>
  );
};

export default GeneralPages;
